// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MockNativeHeader_wrapper__MkWdH","iconButton":"MockNativeHeader_iconButton___aPFE","title":"MockNativeHeader_title__ep0NE"};